import React from 'react';
import '../Css/Footer.css';
export default function Footer() {
    return (
        <footer className="footer">
            <p>© 2025 Victor Murithi. All rights reserved.</p>
        </footer>
    );
}